<template>
  <div>
    <Sidebar></Sidebar>

    <div class="container-fluid px-0">
      <!-- NOTE Header -->
      <div class="row">
        <div class="col px-0">
          <Header :esHome="esHome" />
        </div>
      </div>

      <!-- NOTE portada -->
      <div class="row">
        <div class="col m-0 px-0">
          <Portada :esHome="esHome" :online="online" />
        </div>
      </div>
    </div>

    <!-- NOTE Galeria para desarrollo -->
    <!-- <div class="row" style="display: none;">
      <div class="col-12">
        <Gallery />
      </div>
    </div>-->
    <!-- NOTE section es el arreglo de secciones de root, usamos su id correspondiente -->
    <div v-for="(section, index) in sections" :key="index">
      <Section
        :name="section.titulo"
        :esHome="esHome"
        :id="section.id"
        :index="index"
        :online="online"
      />
      <div class="row py-2 m-0 px-0" :class="{ ocultarClass: esHome }">
        <div class="col-12 m-0 p-0">
          <div class="d-flex justify-content-end">
            <b-button
              class="m-md-2"
              v-b-modal.modal-delete
              variant="danger"
              size="sm"
              :class="{ ocultarClass: esHome }"
              v-on:click="idDeleteSecc = index"
            >Eliminar Sección</b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <!--Modal para confirmar eliminar una sección-->
      <b-modal
        @ok="deleteSection(idDeleteSecc)"
        id="modal-delete"
        title="Eliminar Sección"
        no-close-on-backdrop
      >
        <div class="container">
          <p>¿Eliminar la sección? Se borrará todo su contenido permanentemente.</p>
        </div>
        <template v-slot:modal-footer="{ ok, cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" variant="secondary" @click="cancel()">Cancelar</b-button>
          <b-button size="sm" variant="danger" @click="ok()">Eliminar</b-button>
        </template>
      </b-modal>
    </div>

    <!--Agregar Sección-->
    <div class="d-flex justify-content-center" :class="{ ocultarClass: esHome }">
      <b-button
        :class="{ ocultarClass: esHome }"
        class="m-1"
        variant="success"
        v-b-modal="'modal-' + this.uid"
      >Agregar Sección</b-button>
      <!--<b-button class="m-1" v-show="btnInsertTrivia" v-on:click="generarPHP"
        >Generar PHP</b-button
      >-->
      <b-modal
        @ok="addSection()"
        :id="'modal-' + this.uid"
        title="Nombre de la nueva sección:"
        no-close-on-backdrop
      >
        <input class="py-2 px-4" style="width:100%" v-model="nombreSection" type="text" />
        <template v-slot:modal-footer="{ ok, cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" variant="secondary" @click="cancel()">Cancelar</b-button>
          <b-button size="sm" variant="success" @click="addSection()">Guardar</b-button>
        </template>
      </b-modal>
    </div>

    <div class="row mx-0">
      <div class="col-12 px-0">
        <Footer :esHome="esHome" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Portada from '@/components/Portada.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Section from '@/components/Section.vue'
import Sidebar from '@/components/Sidebar.vue'
import { saveAs } from 'file-saver'
import axios from 'axios'

export default {
  name: 'Home',
  components: { Header, Portada, Sidebar, Footer, Section },
  data() {
    return {
      stringPHP:
        '<?php require_once "conexion.php"; \n if ($conn->connect_error) { die("Error en la conexión: " . $conn->connect_error); } else{ echo "Conexion succesful"; \n',
      sections: [],
      SectionsTotal: 0,
      lastNumber: 0,
      nombreSection: '',
      showTrivia: false,
      btnInsertTrivia: true,
      btnDeleteTrivia: false,
      idDeleteSecc: 0,
      localRoot: [],
      aiuda: [],
      esHome: false,
      online: null
    }
  },

  created() {
    //TODO axios del hitcounter
    // axios.post('hit_counter.php')
    // .then(resp() =>{})
    // .catch(Error =>{
    //   console.log(Error);
    // })

    //si esta conetado a internet
    if (window.navigator.onLine) {
      console.log('online')
      this.online = true
    } else {
      console.log('offline')
      this.online = false
    }

    //console.log(this.$route.path)
    if (this.$route.path === '/') {
      this.esHome = true
    } else {
      this.esHome = false
    }

    let dated = new Date()
    let mes = dated.getMonth() + 1
    let year = dated.getFullYear()

    axios
      .post('hitcounter.php', { mes: mes, year: year })
      .then(resp => {
        console.log(resp.data)
      })
      .catch(Error => {
        console.log(Error)
      })

    let root = window.localStorage.getItem('root')
    this.localRoot = JSON.parse(window.localStorage.getItem('root'))
    let parsedRoot = JSON.parse(root)
    this.aiuda = document.getElementsByClassName('elem-anim')
    //NOTE se obtiene el arreglo de secciones
    this.sections = this.localRoot['componentes']['secciones']
    //this.SectionsTotal = this.localRoot['detalles']['total_sec']
    /*for (var section in this.sections) {
      console.log(this.sections[section])
      this.SectionsTotal++
    }*/
    this.lastNumber = 0
    for (var section in this.sections) {
      this.SectionsTotal++
      this.lastNumber = this.sections[section].id.substring(2)
    }
    console.log(this.SectionsTotal)
    //console.log(this.localRoot['componentes']['secciones'])
    if (parsedRoot['detalles'][0].id) {
      //NOTE aqui obtengo el id del footer
      console.log('Existe footer')
    } else {
      return
    }
  },
  mounted() {
    //let root = window.localStorage.getItem('root')

    //let local = JSON.parse(window.localStorage.getItem('root'))
    //let sectionsLocal = local['componentes']['secciones']
    let elementos = document.getElementsByClassName('elem-anim')
    //for(var element in sectionsLocal[section].subsecciones) {

    /* for(var element in elementos) {
        console.log(element)
      }*/
    window.onscroll = function() {
      //for (var section in sectionsLocal) {
      //console.log(sectionsLocal[section].id)
      for (var element in elementos) {
        //let audio = document.getElementById(sectionsLocal[section].subsecciones[element].id)
        //console.log('soy '+section)
        if (!isNaN(element)) {
          var dist =
            elementos[element].getBoundingClientRect().top + window.scrollY
        }
        //console.log('soy '+elementos[element].dataset.sub)
        //console.log(sectionsLocal[elementos[elementos[element].dataset.sub].dataset.section].subsecciones[elementos[element].dataset.sub].animation)
        if (
          document.body.scrollTop > dist - 400 ||
          document.documentElement.scrollTop > dist - 400
        ) {
          //if (!isNaN(element)) {
          //console.log("vacio?? "+elementos[element].dataset.anim)
          switch (elementos[element].dataset.anim) {
            case 'rl':
              elementos[element].classList.add('animation-slide-r-l')
              break

            case 'lr':
              elementos[element].classList.add('animation-slide-l-r')
              break
            case 'bounce':
              elementos[element].classList.add('animation-bounce')
              break

            case 'fade':
              elementos[element].classList.add('animation-fade')
              break

            default:
              elementos[element].classList.add('animation-slide-l-r')
              break
          }
          //console.log(k+ ' final')
          // }
        }
      }
      //}
    }
  },
  methods: {
    addSection() {
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.sections = this.localRoot['componentes']['secciones']
      this.lastNumber++
      let nombreActual = this.nombreSection
      const newSection = {}
      let idsection = 'id' + this.lastNumber
      //newSection.sectionName = 'Section'
      //newSection.id = this.uid
      newSection.layout = 'dos'
      newSection['bg-img'] = [{ name: 'muestra2.jpg', url: 'laurl' }]
      newSection['bg-position'] = 'center'
      newSection['bg-repeat'] = 'repeat'
      newSection['bg-color'] = '#FAFAFA'
      newSection.titulo = nombreActual
      newSection.stateT = 1
      newSection.orden = this.lastNumber
      newSection.id = idsection
      newSection.subsecciones = []

      const newSubsection = {}
      newSubsection.id = ''
      newSubsection.bgcolor = ''
      newSubsection.elements = []
      newSubsection.position = ''

      const newElement = {}
      newElement.type = 'Texto'
      newElement.id = ''
      newElement.src = [
        {
          name:
            '<p class="ql-align-center">Inserta </p><p class="ql-align-center">un</p><p class="ql-align-center">elemento</p>',
          url:
            'https://firebasestorage.googleapis.com/v0/b/buro-app.appspot.com/o/imagenes%2Fsampleimg.png?alt=media&token=e91303c7-80e1-47cd-942d-3c95ef72ab41'
        }
      ]
      newElement.margin = {
        mt: 0,
        mr: 0,
        mb: 0,
        ml: 0
      }
      newElement.padding = {
        pt: 0,
        pr: 0,
        pb: 0,
        pl: 0
      }
      newElement.position = 'center'
      newElement.animation = 'lr'
      newElement.size = '50'
      newElement.gallery_settings = [
        { existeGaleria: false },
        {
          images: [],
          carousel: [],
          audio: null
        }
      ]
      newElement.extras = []

      var k = 0
      for (var i = 0; i < 4; i++) {
        newSection.subsecciones[i] = newSubsection
        newSection.subsecciones[i].id = idsection + '-element' + k
        for (var j = 0; j < 2; j++) {
          newElement.id = idsection + '-element' + k + '-' + j
          newSection.subsecciones[i].elements[j] = newElement
        }
        k++
      }

      //this.sections.push(newSection)
      this.sections['id' + this.lastNumber] = newSection
      //console.log(this.sections)
      this.nombreSection = ''
      //Se guarda el numero total de secciones
      //this.localRoot['detalles']['total_sec']= this.SectionsTotal
      //Se sobreescribe el arreglo de secciones
      this.localRoot['componentes']['secciones'] = this.sections
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
      this.lastNumber = 0
      this.$router.go({
        path: '/editar',
        force: true
      })
    },
    changeOrder() {
      this.sections.reverse()
    },
    deleteSection(index) {
      this.$delete(this.sections, index)
      this.localRoot = JSON.parse(window.localStorage.getItem('root'))
      this.localRoot['componentes']['secciones'] = this.sections
      let parsedRoot = JSON.stringify(this.localRoot)
      window.localStorage.setItem('root', parsedRoot)
    },
    generarPHP() {
      var sql = '$sql = "'
      for (var section in this.sections) {
        console.log(this.sections[section].id)
        sql +=
          'INSERT INTO revista (nombre_seccion, titulo, likes, lecturas, fecha_creacion) VALUES ("' +
          this.sections[section].id +
          '", "' +
          this.sections[section].titulo +
          '", 0, 0, now()); \n '
      }
      /*this.sections.forEach(section => {
        console.log(section.id)
        console.log(section.name)
        sql +=
          'INSERT INTO revista (nombre_seccion, titulo, likes, lecturas, fecha_creacion) VALUES (' +
          section.id +
          ', ' +
          section.name +
          ', 0, 0, now()); \n '
      })*/
      sql += '";\n'
      var insert = '$conn->multi_query($sql); $conn->close(); \n'
      var finalPHP = this.stringPHP + sql + insert + '?>'
      var blob = new Blob([finalPHP], { type: 'text/plain;charset=utf-8' })
      saveAs(blob, 'inserta_articulos.php')
    }
  }
}
</script>

<style lang="scss">
/*.element {
  border: none !important;
  background: transparent !important;
}*/
.ocultarClass {
  display: none !important;
}
.mostrarClass {
  display: block !important;
}
.posicionar-container {
  background-color: #eaf0e9;
  border: solid #b1b0b0 2px;
  border-radius: 8px;
}
.posicionar-titulo {
  /* background-color: antiquewhite; */
  border-bottom: solid #b1b0b0 2px;
  border-radius: 8px;
}

.ql-align-right {
  text-align: right;
}

.ql-align-center {
  text-align: center;
}

.btn-elemento {
  position: absolute;
  top: -20px;
  right: 0;
  margin: 5px;
}
/*.element {
  border: 1px black dotted;

  background-color: rgba(256, 256, 256, 0.5);
}*/
.stap {
  animation-fill-mode: backwards !important;
  animation-iteration-count: 1 !important;
  opacity: 0;
}

.fade-in {
  animation-name: fadeIn;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
  animation-direction: normal;
  animation-iteration-count: 1;
  animation-delay: 0;
  animation-play-state: running;
}

.animation-fade {
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 0;
  animation-play-state: running;
  opacity: 1 !important;
}
.animation-slide-l-r {
  position: relative;
  animation-name: slidelr;
  animation-duration: 1.5s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 1s;
  animation-play-state: running;
  opacity: 1 !important;
}
.animation-slide-r-l {
  position: relative;
  animation-name: sliderl;
  animation-duration: 1.5s;
  animation-timing-function: ease-in-out;
  /* animation-fill-mode: ; */
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 1s;
  animation-play-state: running;
  opacity: 1 !important;
}
.posicionar-container {
  width: 400px !important;
  right: 0 !important;
  position: absolute;
  z-index: 100;
}
.animation-bounce {
  position: relative;
  animation-name: bounce;
  animation-duration: 1.5s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: none;
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-delay: 1s;
  animation-play-state: running;
  opacity: 1 !important;
}

.row {
  margin: 0 !important;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slidelr {
  from {
    right: 3em;
    opacity: 0;
  }
  to {
    right: 0em;
    opacity: 1;
  }
}
@keyframes sliderl {
  from {
    left: 3em;
    opacity: 0;
  }
  to {
    left: 0em;
    opacity: 1;
  }
}
@keyframes bounce {
  from {
    bottom: 2.5em;
    opacity: 0;
  }
  to {
    bottom: 0em;
    opacity: 1;
  }
}

p {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.ql-indent-1 {
  padding-left: 3em !important;
}
.ql-indent-2 {
  padding-left: 6em !important;
}
.ql-indent-3 {
  padding-left: 9em !important;
}
.ql-indent-4 {
  padding-left: 12em !important;
}
.ql-indent-5 {
  padding-left: 15em !important;
}
.ql-indent-6 {
  padding-left: 18em !important;
}
.ql-indent-7 {
  padding-left: 21em !important;
}
.ql-indent-8 {
  padding-left: 24em !important;
}

.ml-6 {
  margin-left: 4.5rem !important;
}
.mt-6 {
  margin-top: 4.5rem !important;
}
.mr-6 {
  margin-right: 4.5rem !important;
}
.mb-6 {
  margin-bottom: 4.5rem !important;
}

.ml-7 {
  margin-left: 6rem !important;
}
.mt-7 {
  margin-top: 6rem !important;
}
.mr-7 {
  margin-right: 6rem !important;
}
.mb-7 {
  margin-bottom: 6rem !important;
}

.ml-8 {
  margin-left: 7.5rem !important;
}
.mt-8 {
  margin-top: 7.5rem !important;
}
.mr-8 {
  margin-right: 7.5rem !important;
}
.mb-8 {
  margin-bottom: 7.5rem !important;
}
.custom-control {
  min-height: 0 !important;
  padding-left: 0 !important;
}

.custom-control-inline {
  margin-right: 0 !important;
}

.clic:hover {
  cursor: pointer;
}

.text-elem  {
ol {
  counter-reset: item;
  margin: 0 0 1.5em;
  padding: 0;
  > li {
    counter-increment: item;
    list-style-type: none;
    margin: 0;
    padding: 0 0 1rem 2rem;
    text-indent: -1.2rem;
    &::before {
      content: counter(item) '.';
      display: inline-block;
      font-weight: bold;
      padding-right: .5rem;      
      text-align: right;
      width: 1.5rem;
    }
  }
}
}
</style>
